import * as dc from "@/components/layout/list/defaultType";
import { DataListParams, DataListProp, DataParams, LayoutProps } from "../../layoutType";
import dayjs from "dayjs";
import { Debug } from "@/util/debug";
import { fetchCommand, fetchHost } from "@/util/fetchutil";
import { getApiHostname } from "@/util/paramutil";
import { clearIndexedDB } from "@/util/code";
import { getMatchingSelectData, runFormFunction } from "../../input/inputFunction";
import { enLocale, koLocale } from "@/i18n/routing";
export const SettingResult = (props: DataListProp): DataListParams | undefined => {
  const t = props.t;
  const ta = props.ta;
  const result = props.result;
  const params = props.params;
  const form = props.form;
  const formMemo = props.formMemo;
  const setValueList = props.setValueList;
  const formFunction = props.formFunction;
  const dataFunction = props.dataFunction;
  const alertContext = props.alertContext;

  const utcOffset = dayjs().utcOffset() * 60000;

  switch (params?.page.page ?? "") {
    case "CafeUserInfo":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/cafe/userinfo/detail", saveFetch: { fetchUrl: "/api/cafe/userinfo/edit" } },
        //dataResultName: "",
        dataName: "UserInfo",
        useDefaultId: true,
        useList: false,
        dataCols: {
          cafe_user_nick: { ...dc.input, minLength: 3, maxLength: 100, showCount: true },
          cafe_user_auth: {
            ...dc.select,
            codeGroup: "CAUTH",
            maxLength: 300,
            showCount: true,
            disabled: true,
          },
          cafe_user_desc: { ...dc.textAreaM, read: { ...dc.textAreaM.read, readOnly: true } },
          // roaster_user_use: { ...dc.useDefault, disabled: true, read: { display: false } },
          //rgst_at:{...dc.},
          rgst_by: { ...dc.rgst },
          //edit_at:{...dc.},
          edit_by: { ...dc.edit },
        },
        dataReloadButton: false,
        removeButton: false,
        hiddenAds: true,
      };

    case "RoasterUserInfo":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/roaster/userinfo/detail", saveFetch: { fetchUrl: "/api/roaster/userinfo/edit" } },
        //dataResultName: "",
        dataName: "UserInfo",
        useDefaultId: true,
        useList: false,
        dataCols: {
          roaster_user_nick: { ...dc.input, minLength: 3, maxLength: 100, showCount: true },
          roaster_user_auth: {
            ...dc.select,
            codeGroup: "RAUTH",
            maxLength: 300,
            showCount: true,
            disabled: true,
          },
          roaster_user_desc: { ...dc.textAreaM, read: { ...dc.textAreaM.read, readOnly: true } },
          // roaster_user_use: { ...dc.useDefault, disabled: true, read: { display: false } },
          //rgst_at:{...dc.},
          rgst_by: { ...dc.rgst },
          //edit_at:{...dc.},
          edit_by: { ...dc.edit },
        },
        dataReloadButton: false,
        removeButton: false,
        hiddenAds: true,
      };

    case "UserBasicInfo":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/userinfo", updateSaveFetch: { fetchUrl: "/api/userinfo/update" } },
        //dataResultName: "",
        dataName: "UserInfo",
        useDefaultId: true,
        useList: false,
        dataCols: {
          user_img: { ...dc.image, inputClassName: "rounded-full", imageProp: { preview: false }, display: "notNull" },
          user_seq: dc.hidden,
          user_provider: dc.disabled({ ...dc.select, codeGroup: "USRPRVD", display: "notNull" }),
          user_type: dc.disabled({ ...dc.select, codeGroup: "USER" }),
          user_name: dc.input,
          user_email: dc.disabled(dc.input),
          user_id: dc.passwordDisabled,
          user_uuid: dc.passwordDisabled,
          user_serial: dc.hidden,
          rgst_at: dc.at,
          edit_at: { ...dc.at, display: "notNull" },
          user_use: { ...dc.disabled(dc.useDefault), checkUserType: ["SADMIN"] },
          // code_reload_link: {
          //   ...dc.link,
          //   fixedValue: getApiHostname() + "/api/code/reload",
          //   linkProp: { className: "font-bold" },
          //   linkPropOption: { title: "link", newTab: true, linkButtonUse: true, linkButtonFront: true },
          //   checkUserType: ["SADMIN"],
          // },
          code_reload: {
            checkUserType: ["SADMIN", "ADMIN"],
            fieldId: {
              code_reload_button: {
                ...dc.buttonDefault("ArrowsClockwise", () => {
                  fetchCommand("code_reload", t);
                }),
                checkUserType: ["SADMIN", "ADMIN"],
              },
              code_reload_link: {
                ...dc.link,
                fixedValue: getApiHostname() + "/api/code/reload",
                //linkProp: { className: "font-bold mt-2" },
                disabled: true,
                linkPropOption: {
                  title: "link",
                  newTab: true,
                  linkButtonUse: true,
                  // linkButtonFront: false
                },
                checkUserType: ["SADMIN", "ADMIN"],
              },
            },
          },
          db_clear: {
            ...dc.buttonDefault(
              "Trash",
              () => {
                clearIndexedDB();
              },
              "default",
              "db_clear",
              undefined,
              undefined,
              false,
            ),
            edit: { display: false },
          },
          user_delete: {
            ...dc.buttonDefault(
              "UserCircleMinus",
              () => {
                const alert_p = alertContext?.setProp;
                if (alert_p) {
                  alert_p({
                    open: true,
                    title: ta("delete_account"),
                    description: ta("delete_account_detail"),
                    useCancel: true,
                    useOk: true,
                    okClose: true,
                    okFunction: () => {
                      alert_p({ open: true, loading: true, loadingTitle: ta("delete_account_processing") });
                      setTimeout(() => {
                        fetchHost(
                          "/api/userinfo/delete",
                          dc.fetchPostOption,
                          undefined,
                          (data: any) => {
                            Debug(data);
                            if (data.status === "OK") {
                              alert_p({
                                open: true,
                                title: ta("delete_account"),
                                description: ta("delete_ok"),
                                useCancel: false,
                                useOk: true,
                                okClose: true,
                                okFunction: () => {
                                  location.href = "/";
                                },
                              });
                            } else {
                              alert_p({
                                open: true,
                                title: ta("delete_account"),
                                description: ta("error_text"),
                                useCancel: false,
                                useOk: true,
                                okClose: true,
                                okFunction: () => {},
                              });
                            }
                          },
                          () => {},
                        );
                      }, 3000);
                    },
                  });
                }
                // clearIndexedDB();
              },
              "default",
              "user_delete",
              undefined,
              undefined,
              false,
            ),
            read: { display: false },
          },
        },
        dataReloadButton: false,
        removeButton: false,
        hiddenAds: true,
      };
    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_common","system_TABLE_NAME":"country_list","system_table_pk":["country_seq"],"system_table_page":"Country","system_table_path":"setting/country","system_table_page_name":"Country","system_table_auth":["SADMIN","ADMIN"],"system_table_mapper":"country","system_table_detail_result":"country_result","system_table_search_column":["country_filter"],"system_table_search_select":["country_name","country_nick"],"system_table_default_name_column":"country_name","system_table_en_name_column":"country_nick"},
    //--info--"change":{"country_filter":{"COLUMN_TYPE":"selectSearchMulti","COLUMN_CODE_SELECT":"CDFLTR"}}
    //--info--}
    case "Country":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/setting/country/detail/", saveFetch: { fetchUrl: "/api/setting/country/edit" } },
        listFetch: { fetchUrl: "/api/setting/country/list" },
        dataResultName: "country_result",
        dataName: "CountryData",
        listColLinkField: "country_id",
        dataCols: {
          country_seq: dc.hidden,
          country_name: dc.input,
          country_map: {
            ...dc.geoMapChart,
            indexKey: "country_code2",
            indexLabelKey: params?.locale !== enLocale ? "country_name" : "country_nick",
          },
          country_nick: dc.input,
          country_code2: dc.input,
          country_id: { ...dc.input, update: { disabled: true } },
          country_code1: dc.input,
          country_filter: { ...dc.selectSearchMulti, inputClassName: dc.inputCountryClassName, codeGroup: "CDFLTR", selectFilter: "CNTR" },
          // Radar: {
          //   ...dc.cupRadar,
          //   fieldId: "country_seq",
          //   indexKey: "country_id",
          //   indexLabelKey: params?.locale !== enLocale ? "country_name" : "country_nick",
          // },
          rgst_at: dc.at,
          edit_at: { ...dc.at, onChange: (e: any) => (form?.current ? form.current.setFieldValue("rgst_at", e) : "") },
          country_use: dc.useDefault,
        },
        listSearch: [
          // {
          //   ...dc.select,
          //   inputClassName: dc.searchSelectWidth,
          //   codeGroup: "CDFLTR",
          //   selectFilter: "CNTR",
          //   field: "search0",
          //   label: "country_filter",
          //   placeholder: "country_filter",
          //   selectPropOption: { reloadButton: false },
          // },
        ],
        listSearchSelect: [
          { ...dc.input, field: "search_title_all", label: "country_name", placeholder: "country_name" },
          // { ...dc.input, field: "search_type0", label: "country_name", placeholder: "country_name" },
          // { ...dc.input, field: "search_type1", label: "country_nick", placeholder: "country_nick" },
        ],
        listCols: [dc.seqClassName("country_id"), "country_code2", params?.locale === koLocale ? "country_name" : "country_nick"],
      };
    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_common","system_TABLE_NAME":"region_list","system_table_pk":["region_seq"],"system_table_page":"SettingRegion","system_table_path":"setting/country/region","system_table_page_name":"Region","system_table_auth":["SADMIN","ADMIN"],"system_table_mapper":"country","system_table_detail_result":"detail_result","system_table_search_column":["region_country"],"system_table_search_select":["region_name_locale","region_name"],"system_table_order_column":["region_name_locale","region_code","region_country"],"system_table_default_name_column":"region_name_locale","system_table_en_name_column":"region_name"}
    //--info--}
    case "SettingRegion":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/setting/country/region/detail/", saveFetch: { fetchUrl: "/api/setting/country/region/edit" } },
        listFetch: { fetchUrl: "/api/setting/country/region/list" },
        ///api/code/region
        dataResultName: "detail_result",
        dataName: "SettingRegionData",
        listColLinkField: "region_seq",
        dataCols: {
          region_seq: dc.seq,
          region_country: { ...dc.selectCountry, selectChangeLoad: "region_parent_seq" },
          region_parent_seq: {
            ...dc.selectSearch,
            read: { display: "notNull" },
            inputClassName: dc.inputCountryClassName,
            selectPropOption: { reloadButton: true },
            dataUrl: "/api/code/region",
            dataProp: {
              //fixedParam: { is_parent: true },
              valueParam: { region_country: "region_country" },
              requiredParam: ["region_country"],
            },
            dataLabel: {
              value: "region_seq",
              label: [
                { field: "region_name_locale", subs: "region_nick_locale" },
                { field: "region_name", subs: "region_nick" },
              ],
            },
          },
          region_code: dc.input,
          region_name_locale: { ...dc.inputFull, required: true, minLength: 3, maxLength: 300, showCount: true },
          region_name: { ...dc.inputFull, required: true, minLength: 3, maxLength: 300, showCount: true },
          region_nick: { ...dc.inputFull, maxLength: 300, showCount: true },
          region_nick_locale: { ...dc.inputFull, maxLength: 300, showCount: true },

          // region_map:dc.input,
          // region_map_point:dc.input,
          region_desc: { ...dc.textAreaDefault, maxLength: 30000, showCount: true },
          region_use: dc.useDefault,
          rgst_info: dc.rgst_admin,
          edit_info: dc.edit_admin,
        },
        listSearch: [
          {
            ...dc.country,
            inputClassName: dc.searchSelectWidth,
            field: "search0",
            label: "country_label",
            placeholder: "country_label",
            // selectPropOption: { reloadButton: false },
          },
        ],
        listSearchSelect: [{ ...dc.input, field: "search_title_all", label: "region_name_locale", placeholder: "region_name_locale" }],
        listOrder: [
          "region_country_orderasc",
          "region_country_orderdesc",
          "region_code_orderasc",
          "region_code_orderdesc",
          // "region_name_locale_orderdesc",
          // "region_name_locale_orderasc",
        ],
        listCols: [
          //dc.seqClassName("region_seq"),
          "region_code",
          { field: "region_country", codeGroup: "CNTR", label: "country_label" },
          params?.locale === enLocale ? "region_name" : "region_name_locale",
        ],
      };
    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_common","system_TABLE_NAME":"farm_list","system_table_pk":["farm_seq"],"system_table_page":"SettingFarm","system_table_path":"setting/country/farm","system_table_page_name":"Farm","system_table_auth":["SADMIN","ADMIN"],"system_table_mapper":"country","system_table_detail_result":"farm_result","system_table_search_column":["farm_country_code","farm_region_seq"],"system_table_search_select":["farm_name_locale","farm_name","farm_nick_locale","farm_nick"],"system_table_order_column":["farm_name_locale","farm_name","farm_country_code"],"system_table_default_name_column":"farm_name_locale","system_table_en_name_column":"farm_name"}
    //--info--}
    case "SettingFarm":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/setting/country/farm/detail/", saveFetch: { fetchUrl: "/api/setting/country/farm/edit" } },
        listFetch: { fetchUrl: "/api/setting/country/farm/list" },
        dataResultName: "farm_result",
        dataName: "FarmData",
        dataCols: {
          farm_seq: { ...dc.seq, required: true },
          //farm_code: { ...dc.select, maxLength: 45, showCount: true },
          farm_name_locale: { ...dc.input, required: true, minLength: 3, maxLength: 300, showCount: true },
          farm_name: { ...dc.input, required: true, minLength: 3, maxLength: 300, showCount: true },
          farm_nick_locale: { ...dc.input, maxLength: 300, showCount: true },
          farm_nick: { ...dc.input, maxLength: 300, showCount: true },
          farm_country_code: { ...dc.country, maxLength: 45, showCount: true, selectChangeLoad: "farm_region_seq", selectChangeDelay: 100 },
          farm_region_seq: {
            ...dc.selectSearch,
            inputDirect: { target: "farm_region_etc", query: ".farm_region_etc_item" },
            inputClassName: dc.inputCountryClassName,
            //selectPropOption: { reloadButton: false },
            dataUrl: "/api/code/region",
            dataProp: {
              valueParam: { region_country: "farm_country_code" },
              requiredParam: ["region_country"],
            },
            dataLabel: {
              value: "region_seq",
              label: ["region_name_locale", "region_name"],
              labelSort: false,
            },
          },
          farm_region_etc: {
            ...dc.inputFull,
            itemClassName: "farm_region_etc_item",
            maxLength: 300,
            showCount: true,
            label: "blank",
            labelClassName: dc.mobileHidden,
            placeholder: "farm_region_seq",
          },
          // farm_map: { ...dc.textAreaM },
          // farm_map_point: { ...dc.select, maxLength: 45, showCount: true },
          farm_desc: { ...dc.textArea, maxLength: 3000 },
          farm_detail: { ...dc.textAreaM, maxLength: 10000 },
          farm_use: { ...dc.useDefault, required: true },
          //rgst_at:{...dc.},
          rgst_info: { ...dc.rgst },
          //edit_at:{...dc.},
          edit_info: { ...dc.edit },
        },
        listColLinkField: "farm_seq",
        listSearchAll: true,
        listSearchChange: false,
        listSearch: [
          {
            ...dc.coffee_country_feat,
            field: "search0",
            label: "farm_country_code",
            placeholder: "farm_country_code",
            selectChangeLoad: "search1",
            selectChangeDelay: 100,
          },
          {
            ...dc.select,
            field: "search1",
            label: "farm_region_seq",
            placeholder: "farm_region_seq",
            dataUrl: "/api/code/region",
            dataProp: {
              valueParam: { region_country: "search0" },
              requiredParam: ["region_country"],
            },
            dataLabel: {
              value: "region_seq",
              label: ["region_name_locale", "region_name"],
              labelSort: false,
            },
          },
        ],
        listSearchSelect: [
          { ...dc.input, field: "search_title_all", label: "farm_name_locale", placeholder: "farm_name_locale" },
          // { ...dc.input, field: "search_type0", label: "farm_name_locale", placeholder: "farm_name_locale" },
          // { ...dc.input, field: "search_type1", label: "farm_name", placeholder: "farm_name" },
          // { ...dc.input, field: "search_type2", label: "farm_nick_locale", placeholder: "farm_nick_locale" },
          // { ...dc.input, field: "search_type3", label: "farm_nick", placeholder: "farm_nick" },
        ],
        listOrder: [
          "farm_country_code_orderasc",
          "farm_country_code_orderdesc",
          "farm_name_locale_orderasc",
          "farm_name_locale_orderdesc",
          // "farm_name_orderdesc",
          // "farm_name_orderasc",
        ],
        listCols: [
          //"farm_seq",
          //"farm_code",
          "farm_name",
          "farm_name_locale",
          //"farm_nick",
          //"farm_nick_locale",
          //"farm_map",
          //"farm_map_point",
          //"farm_country_seq",
          "farm_country_code",
          "farm_region_seq",
          //"farm_region_etc",
          //"farm_detail"
        ],
      };

    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_common","system_TABLE_NAME":"code_group","system_table_pk":["code_group_seq"],"system_table_page":"CodeGroup","system_table_path":"setting/codegroup","system_table_page_name":"CodeGroup","system_table_auth":["SADMIN","ADMIN"],"system_table_mapper":"code","system_table_detail_result":"codegroup_result","system_table_search_column":[],"system_table_search_select":["code_group_name_kr","code_group_name"],"system_table_order_column":["code_group_name_kr","code_group_id"],"system_table_default_name_column":"code_group_name_kr","system_table_en_name_column":"code_group_name"}
    //--info--}
    case "CodeGroup":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/setting/codegroup/detail/", saveFetch: { fetchUrl: "/api/setting/codegroup/edit" } },
        listFetch: { fetchUrl: "/api/setting/codegroup/list" },
        dataResultName: "codegroup_result",
        dataName: "CodeGroupData",
        listColLinkField: "code_group_id",
        dataPks: "code_group_seq",
        dataCols: {
          code_group_seq: dc.hidden,
          code_group_id: { ...dc.input, update: { disabled: true } },
          code_group_name: dc.input,
          code_group_name_kr: dc.input,
          code_group_desc: dc.input,
          code_group_use: dc.useDefault,
          rgst_info: dc.rgst_admin,
          edit_info: dc.edit_admin,
        },
        listSearchSelect: [
          { ...dc.input, field: "search_title_all", label: "code_group_name_kr", placeholder: "code_group_name_kr" },
          // { ...dc.input, field: "search_type0", label: "code_group_name_kr", placeholder: "code_group_name_kr" },
          // { ...dc.input, field: "search_type1", label: "code_group_name", placeholder: "code_group_name" },
        ],
        listOrder: ["code_group_name_kr_orderasc", "code_group_name_kr_orderdesc", "code_group_id_orderasc", "code_group_id_orderdesc"],
        listCols: [dc.seqClassName("code_group_id"), "code_group_name_kr", "code_group_name"],
      };

    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_common","system_TABLE_NAME":"code_list","system_table_pk":["code_seq"],"system_table_page":"CodeList","system_table_path":"setting/codelist","system_table_page_name":"CodeList","system_table_auth":["SADMIN","ADMIN"],"system_table_mapper":"code","system_table_detail_result":"code_result","system_table_search_column":["code_group_id"],"system_table_search_select":["code_name_kr","code_name"],"system_table_order_column":["code_order","code_name_kr","code_name","code_group_id"],"system_table_default_name_column":"code_name_kr","system_table_en_name_column":"code_name"}
    //--info--}
    case "CodeList":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/setting/codelist/detail/", saveFetch: { fetchUrl: "/api/setting/codelist/edit" } },
        listFetch: { fetchUrl: "/api/setting/codelist/list" },
        dataResultName: "code_result",
        dataName: "CodeListData",
        dataCols: {
          code_seq: { ...dc.seq },
          code_group_seq: { ...dc.number, edit: { disabled: true }, required: true },
          code_group_id: {
            ...dc.selectSearch,
            inputClassName: dc.inputCountryClassName,
            dataUrl: "/api/codegroup/simple",
            dataProp: {
              fixedParam: { showreal: true },
              load: (data, value_data) => {
                const code_group_id = form?.current?.getFieldValue("code_group_id");
                Debug(data, value_data, code_group_id);
                if (code_group_id && data && data instanceof Array) {
                  data.some((item) => {
                    if (item.code_group_id === code_group_id) {
                      setTimeout(() => {
                        form?.current?.setFieldValue("code_group_seq", item.code_group_seq);
                      });
                      Debug(item, item.code_group_seq);
                      return true;
                    } else {
                      return false;
                    }
                  });
                }
              },
            },
            dataLabel: {
              value: "code_group_id",
              label: ["code_group_id", params?.locale === koLocale ? "code_group_name_kr" : "code_group_name"],
              labelSort: true,
            },
            create: { selectChangeSync: { code_group_seq: "code_group_seq" } },
            required: true,
            minLength: 3,
            maxLength: 45,
            showCount: true,
            update: { disabled: true },
          },
          code_id: {
            ...dc.input,
            required: true,
            minLength: 1,
            maxLength: 45,
            showCount: true,
            //update: { disabled: true }
          },
          code_name_kr: { ...dc.input, required: true, minLength: 3, maxLength: 255, showCount: true },
          code_name: { ...dc.input, required: true, minLength: 3, maxLength: 255, showCount: true },
          code_order: { ...dc.number, required: true },
          code_filter: {
            ...dc.selectSearchMulti,
            inputClassName: dc.inputCountryClassName,
            codeGroup: "CDFLTR",
            dataUrl: "/api/codegroup/simple",
            dataProp: {},
            dataLabel: {
              value: "code_group_id",
              label: ["code_group_id", params?.locale === koLocale ? "code_group_name_kr" : "code_group_name"],
              labelSort: true,
            },

            maxLength: 3000,
            showCount: true,
          },
          code_desc: { ...dc.textAreaMDefault },
          code_desc_kr: { ...dc.textAreaMDefault },
          code_alias1: { ...dc.input, maxLength: 255, showCount: true },
          code_alias2: { ...dc.input, maxLength: 255, showCount: true },
          code_alias3: { ...dc.input, maxLength: 255, showCount: true },
          code_alias4: { ...dc.input, maxLength: 255, showCount: true },
          code_use: { ...dc.useDefault, required: true },
          // parent_code_group: { ...dc.number },
          // parent_code: { ...dc.number },
          rgst_info: { ...dc.rgst },
          //rgst_at:{...dc.},
          edit_info: { ...dc.edit },
          //edit_at:{...dc.}
        },
        writeMatching: { search0: "code_group_id" },
        listColLinkField: "code_seq",
        listSearch: [
          {
            ...dc.selectSearch,
            inputClassName: dc.inputCountryClassName,
            dataUrl: "/api/codegroup/simple",
            dataProp: { fixedParam: { showreal: true } },
            dataLabel: {
              value: "code_group_id",
              label: ["code_group_id", params?.locale === koLocale ? "code_group_name_kr" : "code_group_name"],
              labelSort: true,
            },
            field: "search0",
            label: "code_group_id",
            placeholder: "code_group_id",
          },
        ],
        listSearchSelect: [
          { ...dc.input, field: "search_title_all", label: "code_name_kr", placeholder: "code_name_kr" },
          // { ...dc.input, field: "search_type0", label: "code_name_kr", placeholder: "code_name_kr" },
          // { ...dc.input, field: "search_type1", label: "code_name", placeholder: "code_name" },
        ],
        listOrder: [
          // "code_group_id_orderdesc",
          // "code_group_id_orderasc",
          "code_order_orderasc",
          "code_order_orderdesc",
          "code_name_kr_orderasc",
          "code_name_kr_orderdesc",
          // "code_name_orderdesc",
          // "code_name_orderasc",
        ],
        listCols: [
          // "code_seq",
          //"code_group_seq",
          "code_group_id",
          "code_id",
          "code_name_kr",
          "code_name",
          //"code_desc_kr",
          //"code_alias1",
          //"code_alias2",
          //"code_alias3",
          //"code_alias4",
          "code_order",
          //"code_filter",
          //"parent_code_group",
          //"parent_code"
        ],
      };

    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_common","system_TABLE_NAME":"variety_list","system_table_pk":["variety_seq"],"system_table_page":"Variety","system_table_path":"variety","system_table_page_name":"Variety","system_table_auth":["SADMIN","ADMIN"],"system_table_mapper":"code","system_table_detail_result":"variety_result","system_table_search_column":["species_type"],"system_table_search_select":["variety_name_kr","variety_name"],"system_table_order_column":["variety_name_kr","variety_name"],"system_table_default_name_column":"variety_name_kr","system_table_en_name_column":"variety_name"}
    //--info--}
    case "Variety":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/variety/", saveFetch: { fetchUrl: "/api/variety/edit" } },
        listFetch: { fetchUrl: "/api/variety/list" },
        dataResultName: "variety_result",
        dataName: "VarietyData",
        listColLinkField: "variety_id",
        dataCols: {
          variety_seq: dc.hidden,
          species_type: { ...dc.select, codeGroup: "SPC" },
          variety_id: { ...dc.input, maxLength: 45, showCount: true, update: { disabled: true } },
          variety_name: { ...dc.inputFull, maxLength: 250, showCount: true },
          variety_name_kr: { ...dc.inputFull, maxLength: 250, showCount: true },
          variety_desc: { ...dc.textArea, maxLength: 3000 },
          variety_desc_kr: { ...dc.textArea, maxLength: 3000 },
          variety_detail: { ...dc.textAreaM, maxLength: 30000 },
          variety_disp: dc.use,
          variety_use: dc.useDefault,
          rgst_info: dc.rgst_admin,
          edit_info: dc.edit_admin,
        },
        listSearch: [{ ...dc.select, field: "search0", label: "species_type", placeholder: "species_type", codeGroup: "SPC" }],
        listSearchSelect: [
          { ...dc.input, field: "search_title_all", label: "variety_name_kr", placeholder: "variety_name_kr" },
          // { ...dc.input, field: "search_type0", label: "variety_name_kr", placeholder: "variety_name_kr" },
          // { ...dc.input, field: "search_type1", label: "variety_name", placeholder: "variety_name" },
        ],
        listOrder: [
          "variety_name_kr_orderasc",
          "variety_name_kr_orderdesc",
          // "variety_name_orderdesc", "variety_name_orderasc"
        ],
        listCols: [dc.seqClassName("variety_id"), { field: "species_type", codeGroup: "SPC" }, "variety_name_kr", "variety_name"],
      };
      break;

    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm","system_TABLE_NAME":"company_list","system_table_pk":["company_seq"],"system_table_page":"SettingCompany","system_table_path":"setting/company","system_table_page_name":"Company","system_table_auth":["SADMIN","ADMIN"],"system_table_mapper":"company","system_table_detail_result":"detail_result","system_table_search_column":["company_country_code","company_type"],"system_table_search_select":["company_name_locale","company_name","company_nick_locale","company_nick"],"system_table_default_name_column":"company_name_locale","system_table_en_name_column":"company_name"},
    //--info--"change":{"company_name":{"COLUMN_TYPE":"inputFull"},"company_name_locale":{"COLUMN_TYPE":"inputFull"},"company_nick":{"CHECK_LIST":["LIST","READ","CREATE","UPDATE","EXCEL_UP"]},"company_nick_locale":{"CHECK_LIST":["LIST","READ","CREATE","UPDATE","EXCEL_UP"]},"company_country_seq":{"CHECK_LIST":["LIST","READ","CREATE","UPDATE","EXCEL_UP"]},"company_country_code":{"CHECK_LIST":["LIST","READ","CREATE","UPDATE","EXCEL_UP"]},"company_region_seq":{"CHECK_LIST":["LIST","READ","CREATE","UPDATE","EXCEL_UP"]},"company_shop":{"COLUMN_TYPE":"link","CHECK_LIST":["LIST","READ","CREATE","UPDATE","EXCEL_UP"]},"company_detail":{"CHECK_LIST":["LIST","READ","CREATE","UPDATE","EXCEL_UP"]},"company_etc":{"CHECK_LIST":["LIST","READ","CREATE","UPDATE","EXCEL_UP"]},"company_map":{"CHECK_LIST":["LIST","READ","CREATE","UPDATE","EXCEL_UP"]},"company_map_point":{"CHECK_LIST":["LIST","READ","CREATE","UPDATE","EXCEL_UP"]},"company_type":{"COLUMN_CODE_SELECT":"CMPN"}}
    //--info--}
    case "SettingCompany":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/setting/company/detail/", saveFetch: { fetchUrl: "/api/setting/company/edit" } },
        listFetch: { fetchUrl: "/api/setting/company/list" },
        dataResultName: "company_result",
        dataName: "SettingCompanyData",
        dataCols: {
          company_seq: dc.seq,
          company_country_code: {
            ...dc.selectSearch,
            inputClassName: dc.inputCountryClassName,
            codeGroup: "CNTR",
            defaultValue: params?.locale === enLocale ? "USA" : "KOR",
            selectPropOption: { reloadButton: true },
          },
          company_type: { ...dc.select, inputClassName: dc.inputCountryClassName, codeGroup: "CMPN" },
          company_name_locale: {
            ...dc.input,
            required: params?.locale === enLocale ? false : true,
            minLength: 3,
            maxLength: 300,
            showCount: true,
            read: { display: "notNull" },
          },
          company_nick_locale: {
            ...dc.input,
            maxLength: 300,
            showCount: true,
            read: { display: "notNull" },
          },
          company_name: {
            ...dc.input,
            required: params?.locale === enLocale ? true : false,
            minLength: 3,
            maxLength: 300,
            showCount: true,
            read: { display: "notNull" },
          },
          company_nick: {
            ...dc.input,
            maxLength: 300,
            showCount: true,
            read: { display: "notNull" },
          },
          // company_country_seq,
          // company_region_seq,
          company_site: {
            ...dc.link,
            copyProp: { copyButton: true },
            //linkProp: { className: "font-bold" },
            linkPropOption: { newTab: true },
            minLength: 3,
            maxLength: 300,
            showCount: true,
            read: { display: "notNull" },
          },
          company_shop: {
            ...dc.link,
            // readInput: true,
            copyProp: { copyButton: true },
            //linkProp: { className: "font-bold" },
            linkPropOption: {
              //titleField: "company_name_locale",
              newTab: false,
            },
            minLength: 3,
            maxLength: 300,
            showCount: true,
            read: { display: "notNull" },
          },
          company_type_list: { ...dc.textArea, maxLength: 3000 },
          company_detail: { ...dc.textAreaM, maxLength: 10000 },
          company_etc: { ...dc.textAreaM },
          // company_map,
          // company_map_point,
          // company_type_list,
          company_use: dc.useDefault,
          rgst_info: dc.rgst_admin,
          edit_info: dc.edit_admin,
        },
        listColLinkField: "company_seq",
        listCount: true,
        listSearchAll: true,
        listSearch: [
          // { ...dc.country, field: "search0", label: "company_country_code", placeholder: "company_country_code" },
          { ...dc.select, inputType: "select", codeGroup: "CMPN", field: "search1", label: "company_type", placeholder: "company_type" },
        ],
        listSearchSelect: [
          { ...dc.input, field: "search_title_all", label: "company_name_locale", placeholder: "company_name_locale" },
          // { ...dc.inputFull, field: "search_type0", label: "company_name_locale", placeholder: "company_name_locale" },
          // { ...dc.inputFull, field: "search_type1", label: "company_name", placeholder: "company_name" },
          // { ...dc.input, field: "search_type2", label: "company_nick_locale", placeholder: "company_nick_locale" },
          // { ...dc.input, field: "search_type3", label: "company_nick", placeholder: "company_nick" },
        ],
        listCols: [
          //"company_seq",
          params?.locale === enLocale ? "company_name" : "company_name_locale",
          params?.locale === enLocale ? "company_nick" : "company_nick_locale",
          { field: "company_type", codeGroup: "CMPN" },
          { field: "company_country_code", codeGroup: "CNTR" },
        ],
      };
    case "SettingRoaster":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/setting/roaster/detail/", saveFetch: { fetchUrl: "/api/setting/roaster/edit" } },
        listFetch: { fetchUrl: "/api/setting/roaster/list" },
        dataResultName: "detail_result",
        dataName: "SettingRoasterData",
        dataCols: {
          roaster_seq: dc.seq,
          //roaster_uuid: dc.input,
          roaster_country: {
            ...dc.selectCountry,
            defaultValue: params?.locale === enLocale ? "USA" : "KOR",
          },
          roaster_type: { ...dc.select, inputClassName: dc.inputCountryClassName, codeGroup: "RSTR" },
          roaster_name_locale: {
            ...dc.input,
            required: params?.locale === enLocale ? false : true,
            minLength: 3,
            maxLength: 300,
            showCount: true,
          },
          roaster_name: {
            ...dc.input,
            required: params?.locale === enLocale ? true : false,
            minLength: 3,
            maxLength: 300,
            showCount: true,
          },
          //roaster_company_seq: dc.seq,
          roaster_detail: { ...dc.textArea, maxLength: 10000 },
          // roaster_latitude: dc.input,
          // roaster_longitude: dc.input,
          // roaster_radius: dc.input,
          // roaster_region: dc.input,
          roaster_use: dc.useDefault,
          rgst_info: dc.rgst_admin,
          edit_info: dc.edit_admin,
        },
        listColLinkField: "roaster_seq",
        listCols: [
          "roaster_seq",
          params?.locale === enLocale ? "roaster_name" : "roaster_name_locale",
          { field: "roaster_type", codeGroup: "RSTR" },
          { field: "roaster_country", codeGroup: "CNTR" },
        ],
      };
    case "SettingCafe":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/setting/cafe/detail/", saveFetch: { fetchUrl: "/api/setting/cafe/edit" } },
        listFetch: { fetchUrl: "/api/setting/cafe/list" },
        dataResultName: "detail_result",
        dataName: "SettingCafeData",
        dataCols: {
          cafe_seq: dc.seq,
          //cafe_uuid:dc.input,
          cafe_country: {
            ...dc.selectCountry,
            defaultValue: params?.locale === enLocale ? "USA" : "KOR",
          },
          cafe_type: { ...dc.select, inputClassName: dc.inputCountryClassName, codeGroup: "CAFE" },
          cafe_name_locale: {
            ...dc.input,
            required: params?.locale === enLocale ? false : true,
            minLength: 3,
            maxLength: 300,
            showCount: true,
          },
          cafe_name: {
            ...dc.input,
            required: params?.locale === enLocale ? false : true,
            minLength: 3,
            maxLength: 300,
            showCount: true,
          },
          //cafe_company_seq: dc.input,
          cafe_detail: { ...dc.textArea, maxLength: 10000 },
          // cafe_latitude: dc.input,
          // cafe_longitude: dc.input,
          // cafe_radius: dc.input,
          // cafe_region: dc.input,
          // cafe_group_seq: dc.input,
          cafe_use: dc.useDefault,
          rgst_info: dc.rgst_admin,
          edit_info: dc.edit_admin,
        },
        listColLinkField: "cafe_seq",
        listCols: [
          "cafe_seq",
          params?.locale === enLocale ? "cafe_name" : "cafe_name_locale",
          { field: "cafe_type", codeGroup: "CAFE" },
          { field: "cafe_country", codeGroup: "CNTR" },
        ],
      };

    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_common","system_TABLE_NAME":"equip_list","system_table_pk":["equip_seq"],"system_table_page":"SettingEquip","system_table_path":"setting/equip","system_table_page_name":"SettingEquip","system_table_auth":["SADMIN","ADMIN"],"system_table_mapper":"product","system_table_detail_result":"product_result","system_table_search_column":["equip_type"],"system_table_search_select":["equip_name_locale","equip_name"],"system_table_order_column":["equip_name_locale","equip_name","equip_type"],"system_table_default_name_column":"equip_name_locale","system_table_en_name_column":"equip_name"},
    //--info--"change":{"equip_type":{"COLUMN_CODE_SELECT":"EQUIP"},"equip_type_list":{"CHECK_LIST":["LIST","READ","CREATE","UPDATE","EXCEL_UP"],"COLUMN_CODE_SELECT":"EQUIP"},"equip_manufacture_seq":{"COLUMN_TYPE":"selectSearch","COLUMN_CODE_SELECT":"CMPN"},"equip_detail":{"CHECK_LIST":["LIST","READ","CREATE","UPDATE","EXCEL_UP"]}}
    //--info--}
    case "SettingEquip":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/setting/equip/detail/", saveFetch: { fetchUrl: "/api/setting/equip/edit" } },
        listFetch: { fetchUrl: "/api/setting/equip/list" },
        dataResultName: "product_result",
        dataName: "SettingEquipData",
        dataCols: {
          equip_seq: { ...dc.seq },
          equip_name_locale: { ...dc.input, required: true, minLength: 3, maxLength: 300, showCount: true },
          equip_name: { ...dc.input, required: true, minLength: 3, maxLength: 300, showCount: true },
          equip_nick_locale: { ...dc.input, maxLength: 300, showCount: true },
          equip_nick: { ...dc.input, maxLength: 300, showCount: true },
          equip_type: {
            ...dc.select,
            required: true,
            minLength: 3,
            maxLength: 45,
            showCount: true,
            codeGroup: "EQUIP",
            inputClassName: dc.inputCountryClassName,
          },
          // equip_type_list: {
          //   ...dc.selectSearchMulti,
          //   maxLength: 3000,
          //   showCount: true,
          //   codeGroup: "EQUIP",
          //   inputClassName: dc.inputCountryClassName,
          // },
          equip_manufacture_seq: {
            ...dc.selectSearch,
            inputClassName: dc.inputCountryClassName,
            dataUrl: "/api/code/company",
            dataProp: {
              fixedParam: { company_type: "EQD" },
              requiredParam: ["company_type"],
              load: (data, select_data) => {
                // Debug(select_data);
                // const temp_link_function = formFunction?.current.greenbean_seller_link;
                // if (temp_link_function) {
                //   setTimeout(() => {
                //     form?.current?.setFieldValue("greenbean_seller_link", select_data?.company_shop ?? "");
                //     if (temp_link_function["setLinkValue"]) temp_link_function["setLinkValue"](select_data?.company_shop ?? "");
                //   }, 500);
                // }
              },
            },
            dataLabel: {
              value: "company_seq",
              label: [
                { field: "company_name_locale", subs: "company_nick_locale" },
                { field: "company_name", subs: "company_nick" },
              ],
            },

            // codeGroup: "CMPN",
            // inputDirect: "equip_manufacture_seq",
            // selectProp: { mode: "multiple" },
          },
          equip_option: { ...dc.textArea, maxLength: 10000 },
          equip_detail: { ...dc.textArea, maxLength: 10000 },
          equip_use: { ...dc.useDefault, required: true },
          //rgst_at:{...dc.},
          rgst_by: { ...dc.rgst },
          //edit_at:{...dc.},
          edit_by: { ...dc.edit },
        },
        listColLinkField: "equip_seq",
        listSearch: [
          { ...dc.select, inputType: "select", codeGroup: "EQUIP", field: "search0", label: "equip_type", placeholder: "equip_type" },
        ],
        listSearchSelect: [
          { ...dc.input, field: "search_title_all", label: "equip_name_locale", placeholder: "equip_name_locale" },
          // { ...dc.input, field: "search_type0", label: "equip_name_locale", placeholder: "equip_name_locale" },
          // { ...dc.input, field: "search_type1", label: "equip_name", placeholder: "equip_name" },
        ],
        listOrder: ["equip_name_locale_orderasc", "equip_name_locale_orderdesc", "equip_type_orderasc", "equip_type_orderdesc"],
        listCols: [
          //"equip_seq",
          { field: "equip_type", codeGroup: "EQUIP", selectProp: { mode: "multiple" } },
          params?.locale === enLocale ? "equip_name" : "equip_name_locale",
          //{ field: "equip_type_list", codeGroup: "EQUIP", inputDirect: "equip_type_list", selectProp: { mode: "multiple" } },
          //{ field: "equip_manufacture_seq", codeGroup: "CMPN", inputDirect: "equip_manufacture_seq", selectProp: { mode: "multiple" } },
          //"equip_detail",
          //"equip_option"
        ],
      };

    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_common","system_TABLE_NAME":"material_default","system_table_pk":["material_seq"],"system_table_page":"SettingMaterial","system_table_path":"setting/material","system_table_page_name":"SettingMaterial","system_table_auth":["SADMIN","ADMIN"],"system_table_mapper":"product","system_table_detail_result":"detail_result","system_table_search_column":["material_type"],"system_table_search_select":["material_name_locale","material_name"],"system_table_order_column":["material_type","material_name_locale"],"system_table_default_name_column":"material_name_locale","system_table_en_name_column":"material_name"},
    //--info--"change":{"material_type":{"COLUMN_CODE_SELECT":"MTRL"},"material_mass_unit":{"COLUMN_CODE_SELECT":"MASS"}}
    //--info--}
    case "SettingMaterial":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/setting/material/detail/", saveFetch: { fetchUrl: "/api/setting/material/edit" } },
        listFetch: { fetchUrl: "/api/setting/material/list" },
        dataResultName: "detail_result",
        dataName: "SettingMaterialData",
        dataCols: {
          material_seq: { ...dc.seq },
          material_type: {
            ...dc.select,
            inputClassName: dc.inputCountryClassName,
            required: true,
            minLength: 3,
            maxLength: 45,
            codeGroup: "MTRL",
          },
          material_name: { ...dc.input, required: true, minLength: 3, maxLength: 300, showCount: true },
          material_name_locale: { ...dc.input, required: true, minLength: 3, maxLength: 300, showCount: true },
          material_nick: { ...dc.input, required: true, minLength: 3, maxLength: 300, showCount: true },
          material_nick_locale: { ...dc.input, required: true, minLength: 3, maxLength: 300, showCount: true },
          // material_mass_unit: {
          //   ...dc.select,
          //   maxLength: 45,
          //   showCount: true,
          //   codeGroup: "MASS",
          // },
          // material_default_unit: { ...dc.select, maxLength: 45, showCount: true },
          // material_display_unit: { ...dc.select, maxLength: 45, showCount: true },
          // material_default_price: { ...dc.number },
          material_detail: { ...dc.textAreaM },
          material_use: { ...dc.use },
          //rgst_at:{...dc.},
          rgst_info: { ...dc.rgst },
          //edit_at:{...dc.},
          edit_info: { ...dc.edit },
        },
        listColLinkField: "material_seq",
        listSearch: [
          { ...dc.select, inputType: "select", codeGroup: "MTRL", field: "search0", label: "material_type", placeholder: "material_type" },
        ],
        listSearchSelect: [
          { ...dc.input, field: "search_title_all", label: "material_name_locale", placeholder: "material_name_locale" },
          // { ...dc.input, field: "search_type0", label: "material_name_locale", placeholder: "material_name_locale" },
          // { ...dc.input, field: "search_type1", label: "material_name", placeholder: "material_name" },
        ],
        listOrder: ["material_type_orderasc", "material_type_orderdesc", "material_name_locale_orderasc", "material_name_locale_orderdesc"],
        listCols: [
          // "material_seq",
          { field: "material_type", codeGroup: "MTRL", inputDirect: "material_type", selectProp: { mode: "multiple" } },
          // "material_name",
          "material_name_locale",
          //"material_nick",
          //"material_nick_locale",
          //{ field: "material_mass_unit", codeGroup: "MASS", inputDirect: "material_mass_unit", selectProp: { mode: "multiple" } },
          //"material_default_unit",
          //"material_display_unit",
          //"material_default_price",
          //"material_detail"
        ],
      };

    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_greenbean","system_TABLE_NAME":"greenbean_default","system_table_pk":["greenbean_default_seq"],"system_table_page":"GreenbeanDefault","system_table_path":"setting/product/greenbeandefault","system_table_page_name":"SettingGreenbeanDefault","system_table_auth":["SADMIN","ADMIN"],"system_table_mapper":"product","system_table_detail_result":"detail_result","system_table_search_column":["greenbean_process","greenbean_variety_list","greenbean_country_code"],"system_table_search_select":["greenbean_name","greenbean_name_locale","greenbean_nick","greenbean_nick_locale"],"system_table_order_column":["greenbean_name","greenbean_name_locale","greenbean_nick","greenbean_nick_locale"],"system_table_default_name_column":"greenbean_name_locale","system_table_en_name_column":"greenbean_name"}
    //--info--}
    case "SettingGreenbeanDefault":
      return {
        ...result,
        dataFetch: {
          fetchUrl: "/api/setting/product/greenbeandefault/detail/",
          saveFetch: { fetchUrl: "/api/setting/product/greenbeandefault/edit" },
        },
        listFetch: { fetchUrl: "/api/setting/product/greenbeandefault/list" },
        dataResultName: "detail_result",
        dataName: "SettingGreenbeanDefaultData",
        dataInit: (data: any) => {
          const temp_link_function = formFunction?.current.greenbean_seller_link;
          const temp_seller_function = formFunction?.current.greenbean_seller_seq;
          if (temp_link_function && temp_seller_function && temp_seller_function["selectData"]) {
            const select_data = temp_seller_function["selectData"]();
            Debug(select_data);
            form?.current?.setFieldValue("greenbean_seller_link", select_data?.company_shop ?? "");
            if (temp_link_function["setLinkValue"]) temp_link_function["setLinkValue"](select_data?.company_shop ?? "");
          }
        },
        dataCols: {
          greenbean_default_seq: { ...dc.seq, read: { display: false } },
          greenbean_name_locale: {
            ...dc.inputFull,
            labelClassName: dc.strongLabelClassName,
            required: true,
            minLength: 3,
            maxLength: 300,
            showCount: true,
          },
          greenbean_name: {
            ...dc.inputFull,
            labelClassName: dc.strongLabelClassName,
            required: true,
            minLength: 3,
            maxLength: 300,
            showCount: true,
          },
          greenbean_nick_locale: { ...dc.inputFull, maxLength: 300, showCount: true },
          greenbean_nick: { ...dc.inputFull, maxLength: 300, showCount: true },

          //greenbean_importer_seq: dc.number,
          //greenbean_country_seq: dc.number,
          greenbean_country_code: { ...dc.coffee_country_feat, selectChangeLoad: ["greenbean_region_seq", "greenbean_farm_seq"] },
          greenbean_region_seq: {
            ...dc.selectSearch,
            read: { show: "notNull" },
            inputClassName: dc.inputCountryClassName,
            selectPropOption: { reloadButton: true },
            selectChangeLoad: "greenbean_farm_seq",
            inputDirect: { target: "greenbean_region_etc", query: ".greenbean_region_etc_item" },
            dataUrl: "/api/code/region",
            dataProp: {
              fixedParam: { is_parent: false },
              valueParam: { region_country: "greenbean_country_code" },
              requiredParam: ["region_country"],
            },
            dataLabel: {
              value: "region_seq",
              label: [
                { field: "region_name_locale", subs: "region_nick_locale" },
                { field: "region_name", subs: "region_nick" },
              ],
            },
          },
          greenbean_region_etc: {
            ...dc.inputFull,
            itemClassName: "greenbean_region_etc_item",
            maxLength: 300,
            showCount: true,
            label: "blank",
            labelClassName: dc.mobileHidden,
            placeholder: "greenbean_region_seq",
          },
          greenbean_farm_seq: {
            ...dc.selectSearch,
            read: { show: "notNull" },
            inputClassName: dc.inputCountryClassName,
            inputDirect: { target: "greenbean_farm_etc", query: ".greenbean_farm_etc_item" },
            dataUrl: "/api/code/farm",
            dataProp: {
              valueParam: { region_country: "greenbean_country_code", farm_region_seq: "greenbean_region_seq" },
              requiredParam: ["region_country"],
            },
            dataLabel: {
              value: "farm_seq",
              label: ["farm_name_locale", "farm_name"],
              labelSort: false,
            },
          },
          greenbean_farm_etc: {
            ...dc.inputFull,
            itemClassName: "greenbean_farm_etc_item",
            maxLength: 300,
            showCount: true,
            label: "blank",
            labelClassName: dc.mobileHidden,
            placeholder: "greenbean_farm_seq",
          },

          //greenbean_variety: { ...dc.variety, selectProp: { inputDirect: "greenbean_variety_etc" } },
          greenbean_variety_list: {
            ...dc.varietyMultiFeat,
            inputDirect: { target: "greenbean_variety_etc", query: ".greenbean_variety_etc_item" },
            read: {
              onClick: dc.clickDefault(
                (e: any) => {
                  alert(e);
                },
                () => {
                  alert("해당 품종에 대한 정보가 없습니다.");
                },
              ),
            },
          },
          greenbean_variety_etc: {
            ...dc.inputFull,
            itemClassName: "greenbean_variety_etc_item",
            minLength: 3,
            maxLength: 1000,
            showCount: true,
            label: "blank",
            labelClassName: dc.mobileHidden,
            placeholder: "greenbean_variety_list",
          },
          greenbean_grade: { ...dc.gradeFeat },
          greenbean_grade_detail: { ...dc.gradeDetailFeat },
          greenbean_process: { ...dc.processFeat, inputDirect: { target: "greenbean_process_etc", query: ".greenbean_process_etc_item" } },
          greenbean_process_etc: {
            ...dc.inputFull,
            itemClassName: "greenbean_process_etc_item",
            minLength: 3,
            maxLength: 1000,
            showCount: true,
            label: "blank",
            labelClassName: dc.mobileHidden,
            placeholder: "greenbean_process",
          },
          greenbean_seller_seq: {
            ...dc.selectSearch,
            dataUrl: "/api/code/company",
            dataProp: {
              fixedParam: { company_type: "GBD" },
              requiredParam: ["company_type"],
              load: (data, select_data) => {
                Debug(select_data);
                const temp_link_function = formFunction?.current.greenbean_seller_link;
                if (temp_link_function) {
                  setTimeout(() => {
                    form?.current?.setFieldValue("greenbean_seller_link", select_data?.company_shop ?? "");
                    if (temp_link_function["setLinkValue"]) temp_link_function["setLinkValue"](select_data?.company_shop ?? "");
                  }, 500);
                }
              },
            },
            dataLabel: {
              value: "company_seq",
              label: [
                { field: "company_nick_locale", subs: "company_nick" },
                { field: "company_name_locale", subs: "company_name" },
              ],
            },
            inputClassName: dc.inputCountryClassName,
            inputDirect: { target: "greenbean_seller_etc", query: ".greenbean_seller_etc_item" },
            onChange: (data) => {
              const temp_link_function = formFunction?.current.greenbean_seller_link;
              const temp_seller_function = formFunction?.current.greenbean_seller_seq;

              if (temp_link_function && temp_seller_function) {
                const select_data = temp_seller_function["selectData"]();
                form?.current?.setFieldValue("greenbean_seller_link", select_data?.company_shop ?? "");
                if (temp_link_function["setLinkValue"]) temp_link_function["setLinkValue"](select_data?.company_shop ?? "");
              }
            },
            //clearProp: { clearButton: true },
          },
          greenbean_seller_etc: {
            ...dc.inputFull,
            itemClassName: "greenbean_seller_etc_item",
            minLength: 3,
            maxLength: 1000,
            showCount: true,
            label: "blank",
            labelClassName: dc.mobileHidden,
            placeholder: "greenbean_seller_seq",
          },
          greenbean_seller_link: {
            ...dc.link,
            copyProp: { copyButton: true },
            linkPropOption: { newTab: true },
            minLength: 3,
            maxLength: 300,
            showCount: true,
            readOnly: true,
            //readInput: true,
            noItem: false,
            saveData: false,
            //read: { display: "notNull" },
          },

          greenbean_detail_explain: {
            label: "blank",
            labelClassName: dc.mobileHidden,
            fieldId: {
              greenbean_detail_min: {
                valueType: "number",
                type: "number",
                inputClassName: dc.greenbeanMinMaxWidth + " text-last",
                placeholder: "min_value",
                disabled: true,
                readOnly: true,
                variant: "borderless",
                noItem: true,
                //clearProp: { clearButton: true },
              },
              greenbean_detail_max: {
                valueType: "number",
                type: "number",
                inputClassName: dc.greenbeanMinMaxWidth + " text-last",
                placeholder: "max_value",
                disabled: true,
                readOnly: true,
                variant: "borderless",
                noItem: true,
                //clearProp: { clearButton: true },
              },
            },
          },

          altitude: {
            fieldId: {
              greenbean_altitude_min: {
                ...dc.altitude,
                inputClassName: dc.greenbeanMinMaxWidth + " text-last",
                //clearProp: { clearButton: true },
              },
              greenbean_altitude_max: {
                ...dc.altitude,
                inputClassName: dc.greenbeanMinMaxWidth + " text-last",
                read: { display: ["notNull", { greenbean_altitude_min: "notEquals" }] },
              },
            },
          },
          moisture: {
            fieldId: {
              greenbean_moisture_min: { ...dc.moisture, inputClassName: dc.greenbeanMinMaxWidth + " text-last" },
              greenbean_moisture_max: {
                ...dc.moisture,
                inputClassName: dc.greenbeanMinMaxWidth + " text-last",
                read: { display: ["notNull", { greenbean_moisture_min: "notEquals" }] },
              },
            },
          },
          greenbean_density: {
            fieldId: {
              greenbean_density_min: { ...dc.density, inputClassName: dc.greenbeanMinMaxWidth + " text-last" },
              greenbean_density_max: {
                ...dc.density,
                inputClassName: dc.greenbeanMinMaxWidth + " text-last",
                read: { display: ["notNull", { greenbean_density_min: "notEquals" }] },
              },
            },
          },
          agtron: {
            fieldId: {
              greenbean_agtron_min: { ...dc.agtron, inputClassName: dc.greenbeanMinMaxWidth },
              greenbean_agtron_max: {
                ...dc.agtron,
                inputClassName: dc.greenbeanMinMaxWidth,
                read: { display: ["notNull", { greenbean_agtron_min: "notEquals" }] },
              },
            },
          },
          harvest: {
            fieldId: {
              greenbean_harvest_min: { ...dc.monthSelectFn(params?.locale), inputClassName: dc.greenbeanMinMaxWidth },
              greenbean_harvest_max: {
                ...dc.monthSelectFn(params?.locale),
                inputClassName: dc.greenbeanMinMaxWidth,
                read: { display: ["notNull", { greenbean_harvest_min: "notEquals" }] },
              },
            },
          },
          roasting_recommended: {
            fieldId: {
              greenbean_roasting_min: { ...dc.agtron, inputClassName: dc.greenbeanMinMaxWidth },
              greenbean_roasting_max: {
                ...dc.agtron,
                inputClassName: dc.greenbeanMinMaxWidth,
                read: { display: ["notNull", { greenbean_roasting_min: "notEquals" }] },
              },
            },
          },
          greenbean_desc: { ...dc.textAreaDefault, maxLength: 10000, showCount: true },
          greenbean_use: dc.useDefault,

          rgst_info: dc.rgst_admin,
          edit_info: dc.edit_admin,
        },
        listColLinkField: "greenbean_default_seq",
        listSearch: [
          {
            ...dc.process,
            codeGroupLabel: undefined,
            field: "search0",
            label: "greenbean_process",
            placeholder: "greenbean_process",
            inputClassName: dc.searchSelectWidth,
            selectPropOption: { reloadButton: false },
          },
          {
            ...dc.variety,
            codeGroupLabel: undefined,
            field: "search1",
            label: "greenbean_variety_list",
            placeholder: "greenbean_variety_list",
            inputClassName: dc.searchSelectWidth,
            selectPropOption: { reloadButton: false },
          },
          {
            ...dc.coffee_country,
            field: "search2",
            label: "greenbean_country_code",
            placeholder: "greenbean_country_code",
            inputClassName: dc.searchSelectWidth,
            selectPropOption: { reloadButton: false },
          },
        ],
        listSearchSelect: [
          { ...dc.input, inputType: "input", field: "search_type0", label: "greenbean_name_locale", placeholder: "greenbean_name_locale" },
          { ...dc.input, inputType: "input", field: "search_type1", label: "greenbean_name", placeholder: "greenbean_name" },
          // { ...dc.input, inputType: "input", field: "search_type3", label: "greenbean_nick_locale", placeholder: "greenbean_nick_locale" },
          // { ...dc.input, inputType: "input", field: "search_type2", label: "greenbean_nick", placeholder: "greenbean_nick" },
        ],
        listOrder: [
          "greenbean_name_locale_orderasc",
          "greenbean_name_locale_orderdesc",
          // "greenbean_name_orderasc",
          // "greenbean_name_orderdesc",
          // "greenbean_nick_locale_orderdesc",
          // "greenbean_nick_locale_orderasc",
          // "greenbean_nick_orderdesc",
          // "greenbean_nick_orderasc",
        ],
        listCount: true,
        listCols: [
          params?.locale !== enLocale ? "greenbean_nick_locale" : "greenbean_nick",
          { field: "greenbean_country_code", codeGroup: "CNTR" },
          { field: "greenbean_grade_detail", label: "grade_detail_label", codeGroup: "BQLT" },
          { field: "greenbean_variety_list", codeGroup: "VRT", inputDirect: "greenbean_variety_etc", selectProp: { mode: "multiple" } },
          { field: "greenbean_process", codeGroup: "PRCS", inputDirect: "greenbean_process_etc" },
        ],
      };
    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_greenbean","system_TABLE_NAME":"greenbean_year","system_table_pk":["greenbean_year","greenbean_defaultyear_seq"],"system_table_page":"SettingGreenbeanYear","system_table_path":"setting/product/greenbeanyear","system_table_page_name":"GreenbeanYear","system_table_auth":["SADMIN","ADMIN"],"system_table_mapper":"product","system_table_detail_result":"detail_result","system_table_search_column":["greenbean_year","greenbean_process","greenbean_variety_list","greenbean_country_code"],"system_table_search_select":["greenbean_name_locale","greenbean_name"],"system_table_order_column":["greenbean_name_locale","greenbean_name","greenbean_year"],"system_table_default_name_column":"greenbean_name_locale","system_table_en_name_column":"greenbean_name"}
    //--info--}
    case "SettingGreenbeanYear":
      return {
        ...result,
        dataFetch: {
          fetchUrl: "/api/setting/product/greenbeanyear/detail",
          saveFetch: { fetchUrl: "/api/setting/product/greenbeanyear/edit" },
        },
        listFetch: { fetchUrl: "/api/setting/product/greenbeanyear/list" },
        dataResultName: "detail_result",
        dataName: "GreenbeanYearData",
        dataInit: (data: any) => {
          const temp_link_function = formFunction?.current.greenbean_seller_link;
          const temp_seller_function = formFunction?.current.greenbean_seller_seq;
          if (temp_link_function && temp_seller_function && temp_seller_function["selectData"]) {
            const select_data = temp_seller_function["selectData"]();
            Debug(select_data);
            form?.current?.setFieldValue("greenbean_seller_link", select_data?.company_shop ?? "");
            if (temp_link_function["setLinkValue"]) temp_link_function["setLinkValue"](select_data?.company_shop ?? "");
          }
        },
        dataCols: {
          greenbean_year: { ...dc.year, required: true, defaultValue: new Date() },
          greenbean_seller_seq: {
            ...dc.selectSearch,
            read: { show: "notNull" },
            //update: { disabled: true },
            dataUrl: "/api/code/company",
            dataProp: {
              fixedParam: { company_type: "GBD" },
              requiredParam: ["company_type"],
              load: (data, select_data) => {
                Debug(select_data);
                const temp_link_function = formFunction?.current.greenbean_seller_link;
                if (temp_link_function) {
                  setTimeout(() => {
                    form?.current?.setFieldValue("greenbean_seller_link", select_data?.company_shop ?? "");
                    if (temp_link_function["setLinkValue"]) temp_link_function["setLinkValue"](select_data?.company_shop ?? "");
                  }, 500);
                }
              },
            },
            dataLabel: {
              value: "company_seq",
              label: [
                { field: "company_nick_locale", subs: "company_nick" },
                { field: "company_name_locale", subs: "company_name" },
              ],
              labelSort: true,
            },
            inputClassName: dc.inputCountryClassName,
            inputDirect: { target: "greenbean_seller_etc", query: ".greenbean_seller_etc_item" },
            onChange: (data) => {
              const temp_link_function = formFunction?.current.greenbean_seller_link;
              const temp_seller_function = formFunction?.current.greenbean_seller_seq;

              if (temp_link_function && temp_seller_function) {
                const select_data = temp_seller_function["selectData"]();
                form?.current?.setFieldValue("greenbean_seller_link", select_data?.company_shop ?? "");
                if (temp_link_function["setLinkValue"]) temp_link_function["setLinkValue"](select_data?.company_shop ?? "");
              }
            },
            selectChangeLoad: ["greenbean_default_seq"],
            //clearProp: { clearButton: true },
          },
          greenbean_seller_etc: {
            ...dc.inputFull,
            itemClassName: "greenbean_seller_etc_item",
            minLength: 3,
            maxLength: 1000,
            showCount: true,
            label: "blank",
            labelClassName: dc.mobileHidden,
            placeholder: "greenbean_seller_seq",
          },

          greenbean_country_code: {
            ...dc.coffee_country,
            update: { disabled: true },
            selectChangeLoad: ["greenbean_region_seq", "greenbean_farm_seq", "greenbean_default_seq"],
          },

          greenbean_default_seq: {
            ...dc.selectSearch,
            update: { disabled: true },
            inputClassName: dc.inputCountryClassName,
            dataUrl: "/api/code/greenbean/default",
            dataProp: {
              requiredParam: ["greenbean_seller_seq"],
              valueParam: { greenbean_country_code: "greenbean_country_code", greenbean_seller_seq: "greenbean_seller_seq" },
              load: (data, select_data) => {
                Debug(data, select_data);
              },
            },
            widthFull: true,
            dataLabel: {
              value: "greenbean_default_seq",
              label: [
                params?.locale === enLocale
                  ? { field: "greenbean_name", subs: "greenbean_nick" }
                  : { field: "greenbean_name_locale", subs: "greenbean_nick_locale" },
              ],
              labelSort: true,
            },
            onChange: (data) => {
              // const selectData = runFormFunction(formFunction?.current, "greenbean_default_seq", "selectData");
              // Debug(selectData, formMemo?.current["greenbean_default_seq"]);
              const result = getMatchingSelectData(form?.current, formFunction?.current, formMemo?.current, "greenbean_default_seq", [
                "greenbean_default_seq",
                "greenbean_country_seq",
                "greenbean_seller_seq",
                "greenbean_harvest_min",
                "greenbean_harvest_max",
                "greenbean_use",
                "edit_at",
              ]);
              //Debug(result);
              form?.current?.setFieldsValue(result);
              setTimeout(() => {
                runFormFunction(formFunction?.current, ["greenbean_region_seq","greenbean_farm_seq"], "changeLoad");
              }, dc.setTimeoutShort);
              //greenbean_region_seq, greenbean_farm_seq
            },
            selectFieldFilter: { greenbean_country_code: "greenbean_country_code" },
          },
          greenbean_name_locale: {
            ...dc.inputFull,
            labelClassName: dc.strongLabelClassName,
            required: true,
            minLength: 3,
            maxLength: 300,
            showCount: true,
          },
          greenbean_name: {
            ...dc.inputFull,
            labelClassName: dc.strongLabelClassName,
            required: true,
            minLength: 3,
            maxLength: 300,
            showCount: true,
          },
          greenbean_nick_locale: { ...dc.inputFull, maxLength: 300, showCount: true },
          greenbean_nick: { ...dc.inputFull, maxLength: 300, showCount: true },

          greenbean_seller_link: {
            ...dc.link,
            read: { display: "notNull" },
            displayCheckIds: ["greenbean_seller_seq"],
            update: { disabled: true },
            copyProp: { copyButton: true },
            linkPropOption: { newTab: true },
            minLength: 3,
            maxLength: 300,
            showCount: true,
            readOnly: true,
            //readInput: true,
            noItem: false,
            saveData: false,
            //read: { display: "notNull" },
          },

          //greenbean_importer_seq: dc.number,
          //greenbean_country_seq: dc.number,
          greenbean_region_seq: {
            ...dc.selectSearch,
            read: { show: "notNull" },
            inputClassName: dc.inputCountryClassName,
            selectPropOption: { reloadButton: true },
            selectChangeLoad: "greenbean_farm_seq",
            inputDirect: { target: "greenbean_region_etc", query: ".greenbean_region_etc_item" },
            dataUrl: "/api/code/region",
            dataProp: {
              fixedParam: { is_parent: false },
              valueParam: { region_country: "greenbean_country_code" },
              requiredParam: ["region_country"],
            },
            dataLabel: {
              value: "region_seq",
              label: [
                { field: "region_name_locale", subs: "region_nick_locale" },
                { field: "region_name", subs: "region_nick" },
              ],
            },
          },
          greenbean_region_etc: {
            ...dc.inputFull,
            itemClassName: "greenbean_region_etc_item",
            maxLength: 300,
            showCount: true,
            label: "blank",
            labelClassName: dc.mobileHidden,
            placeholder: "greenbean_region_seq",
          },
          greenbean_farm_seq: {
            ...dc.selectSearch,
            read: { show: "notNull" },
            inputClassName: dc.inputCountryClassName,
            inputDirect: { target: "greenbean_farm_etc", query: ".greenbean_farm_etc_item" },
            dataUrl: "/api/code/farm",
            dataProp: {
              valueParam: { region_country: "greenbean_country_code", farm_region_seq: "greenbean_region_seq" },
              requiredParam: ["region_country"],
            },
            dataLabel: {
              value: "farm_seq",
              label: ["farm_name_locale", "farm_name"],
              labelSort: false,
            },
          },
          greenbean_farm_etc: {
            ...dc.inputFull,
            itemClassName: "greenbean_farm_etc_item",
            maxLength: 300,
            showCount: true,
            label: "blank",
            labelClassName: dc.mobileHidden,
            placeholder: "greenbean_farm_seq",
          },

          //greenbean_variety: { ...dc.variety, selectProp: { inputDirect: "greenbean_variety_etc" } },
          greenbean_variety_list: {
            ...dc.varietyMultiFeat,
            inputDirect: { target: "greenbean_variety_etc", query: ".greenbean_variety_etc_item" },
            read: {
              onClick: dc.clickDefault(
                (e: any) => {
                  alert(e);
                },
                () => {
                  alert("해당 품종에 대한 정보가 없습니다.");
                },
              ),
            },
          },
          greenbean_variety_etc: {
            ...dc.inputFull,
            itemClassName: "greenbean_variety_etc_item",
            minLength: 3,
            maxLength: 1000,
            showCount: true,
            label: "blank",
            labelClassName: dc.mobileHidden,
            placeholder: "greenbean_variety_list",
          },
          greenbean_grade: { ...dc.gradeFeat },
          greenbean_grade_detail: { ...dc.gradeDetailFeat },
          greenbean_process: { ...dc.processFeat, inputDirect: { target: "greenbean_process_etc", query: ".greenbean_process_etc_item" } },
          greenbean_process_etc: {
            ...dc.inputFull,
            itemClassName: "greenbean_process_etc_item",
            minLength: 3,
            maxLength: 1000,
            showCount: true,
            label: "blank",
            labelClassName: dc.mobileHidden,
            placeholder: "greenbean_process",
          },

          greenbean_detail_explain: {
            label: "blank",
            labelClassName: dc.mobileHidden,
            fieldId: {
              greenbean_detail_min: {
                valueType: "number",
                type: "number",
                inputClassName: dc.greenbeanMinMaxWidth + " text-last",
                placeholder: "min_value",
                disabled: true,
                readOnly: true,
                variant: "borderless",
                noItem: true,
                //clearProp: { clearButton: true },
              },
              greenbean_detail_max: {
                valueType: "number",
                type: "number",
                inputClassName: dc.greenbeanMinMaxWidth + " text-last",
                placeholder: "max_value",
                disabled: true,
                readOnly: true,
                variant: "borderless",
                noItem: true,
                //clearProp: { clearButton: true },
              },
            },
          },

          altitude: {
            fieldId: {
              greenbean_altitude_min: {
                ...dc.altitude,
                inputClassName: dc.greenbeanMinMaxWidth + " text-last",
                //clearProp: { clearButton: true },
              },
              greenbean_altitude_max: {
                ...dc.altitude,
                inputClassName: dc.greenbeanMinMaxWidth + " text-last",
                read: { display: ["notNull", { greenbean_altitude_min: "notEquals" }] },
              },
            },
          },
          moisture: {
            fieldId: {
              greenbean_moisture_min: { ...dc.moisture, inputClassName: dc.greenbeanMinMaxWidth + " text-last" },
              greenbean_moisture_max: {
                ...dc.moisture,
                inputClassName: dc.greenbeanMinMaxWidth + " text-last",
                read: { display: ["notNull", { greenbean_moisture_min: "notEquals" }] },
              },
            },
          },
          greenbean_density: {
            fieldId: {
              greenbean_density_min: { ...dc.density, inputClassName: dc.greenbeanMinMaxWidth + " text-last" },
              greenbean_density_max: {
                ...dc.density,
                inputClassName: dc.greenbeanMinMaxWidth + " text-last",
                read: { display: ["notNull", { greenbean_density_min: "notEquals" }] },
              },
            },
          },
          agtron: {
            fieldId: {
              greenbean_agtron_min: { ...dc.agtron, inputClassName: dc.greenbeanMinMaxWidth },
              greenbean_agtron_max: {
                ...dc.agtron,
                inputClassName: dc.greenbeanMinMaxWidth,
                read: { display: ["notNull", { greenbean_agtron_min: "notEquals" }] },
              },
            },
          },
          harvest: {
            fieldId: {
              greenbean_harvest_min: {
                ...dc.month,
                inputClassName: dc.greenbeanMinMaxWidth,
                //dateProp: { nowButton: false }
              },
              greenbean_harvest_max: {
                ...dc.month,
                inputClassName: dc.greenbeanMinMaxWidth,
                //dateProp: { nowButton: false },
                read: { display: ["notNull", { greenbean_harvest_min: "notEquals" }] },
              },
            },
          },
          roasting_recommended: {
            fieldId: {
              greenbean_roasting_min: { ...dc.agtron, inputClassName: dc.greenbeanMinMaxWidth },
              greenbean_roasting_max: {
                ...dc.agtron,
                inputClassName: dc.greenbeanMinMaxWidth,
                read: { display: ["notNull", { greenbean_roasting_min: "notEquals" }] },
              },
            },
          },
          // greenbean_ref_year: { ...dc.year },
          // greenbean_ref_seq: { ...dc.select },
          greenbean_import_date: { ...dc.date, maxLength: 8, showCount: true },
          greenbean_packaging_date: { ...dc.date, maxLength: 8, showCount: true },
          greenbean_desc: { ...dc.textAreaDefault, maxLength: 10000, showCount: true },
          greenbean_use: dc.useDefault,

          rgst_info: dc.rgst_admin,
          edit_info: dc.edit_admin,
        },
        listColLinkField: ["greenbean_year", "greenbean_default_seq"],
        writeMatching: { search0: "greenbean_year" },
        listSearch: [
          {
            ...dc.year,
            field: "search0",
            label: "greenbean_year",
            placeholder: "greenbean_year",
            placeholderTransition: true,
          },
          {
            ...dc.process,
            codeGroupLabel: undefined,
            field: "search1",
            label: "greenbean_process",
            placeholder: "greenbean_process",
            inputClassName: dc.searchSelectWidth,
            selectPropOption: { reloadButton: false },
          },
          {
            ...dc.variety,
            codeGroupLabel: undefined,
            field: "search2",
            label: "greenbean_variety_list",
            placeholder: "greenbean_variety_list",
            inputClassName: dc.searchSelectWidth,
            selectPropOption: { reloadButton: false },
          },
          {
            ...dc.coffee_country,
            field: "search3",
            label: "greenbean_country_code",
            placeholder: "greenbean_country_code",
            inputClassName: dc.searchSelectWidth,
            selectPropOption: { reloadButton: false },
          },
        ],
        listSearchSelect: [
          { ...dc.input, field: "search_title_all", label: "greenbean_name_locale", placeholder: "greenbean_name_locale" },
          // { ...dc.input, field: "search_type0", label: "greenbean_name_locale", placeholder: "greenbean_name_locale" },
          // { ...dc.textArea, field: "search_type1", label: "greenbean_name", placeholder: "greenbean_name" },
        ],
        listOrder: [
          "greenbean_year_orderdesc",
          "greenbean_year_orderasc",
          "greenbean_name_locale_orderasc",
          "greenbean_name_locale_orderdesc",
          // "greenbean_name_orderasc",
          // "greenbean_name_orderdesc",
        ],
        listCols: [
          "greenbean_year",
          // "greenbean_defaultyear_seq",
          //"greenbean_default_seq",
          //"greenbean_ref_year",
          //"greenbean_ref_seq",
          params?.locale !== enLocale ? "greenbean_nick_locale" : "greenbean_nick",
          //"greenbean_nick",
          //"greenbean_nick_locale",
          //"greenbean_importer_seq",
          //"greenbean_seller_seq",
          //"greenbean_country_seq",
          { field: "greenbean_country_code", codeGroup: "CNTR" },
          //"greenbean_region_seq",
          //"greenbean_region_etc",
          //"greenbean_farm_seq",
          //"greenbean_farm_etc",
          //"greenbean_variety",
          { field: "greenbean_grade_detail", label: "grade_detail_label", codeGroup: "BQLT" },
          { field: "greenbean_variety_list", codeGroup: "VRT", inputDirect: "greenbean_variety_etc", selectProp: { mode: "multiple" } },
          //"greenbean_variety_etc",
          { field: "greenbean_process", codeGroup: "PRCS", inputDirect: "greenbean_process_etc" },
          //"greenbean_process_etc",
          //"greenbean_altitude_min",
          //"greenbean_altitude_max",
          //"greenbean_moisture_min",
          //"greenbean_moisture_max",
          //"greenbean_agtron_min",
          //"greenbean_agtron_max",
          //"greenbean_harvest_min",
          //"greenbean_harvest_max",
          //"greenbean_roasting_min",
          //"greenbean_roasting_max",
          //"greenbean_import_date",
          //"greenbean_packaging_date"
          //params?.locale !== enLocale ? "greenbean_name_locale" : "greenbean_name",
        ],
      };

    default:
      return undefined;
  }
};
